import {
    ChangeDetectionStrategy, Component, ContentChild, HostBinding, Input, OnChanges,
    SimpleChanges
} from "@angular/core";
import {FUIIconComponent} from "../icons/icon/icon.component";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-empty",
    styleUrls: ["./empty.component.scss"],
    templateUrl: "./empty.component.html",
    standalone: false
})
export class FUIEmptyComponent {
    @Input() description: string;
    @ContentChild(FUIIconComponent) public icon: FUIIconComponent;
    @Input() title: string;

    constructor() {
        this.description = "fui.empty.description";
        this.title = "fui.empty.title";
    }
}
